// JDGM: anonymiser les noms -> "Client J." ou "M./Mme X."
(function(){
  // —— Réglages (modifiez这里就行) ——
  var PREFIX = 'Client'; // 可改为 'M.' 或 'Mme'
  var STANDARD_ANON = 'Client vérifié'; // 统一“匿名”显示

  function maskOne(el){
    if (!el || el.dataset.jdgmMasked) return;
    var raw = (el.textContent || '').trim();
    if (!raw) return;

    // 统一“匿名”词
    if (/anonym|client\s*v[ée]rifi[ée]/i.test(raw)) {
      el.textContent = STANDARD_ANON;
      el.dataset.jdgmMasked = '1';
      return;
    }

    // 取最后一个“看起来像姓氏”的词的首字母
    var cleaned = raw.replace(/\s+/g,' ').trim();
    var parts = cleaned.split(' ');
    var last = parts[parts.length - 1] || cleaned.charAt(0);
    last = (last || '').replace(/[^A-Za-zÀ-ÖØ-öø-ÿ]/g,''); // 去掉标点
    var initial = (last.charAt(0) || '').toUpperCase();

    // 生成脱敏显示
    var masked = initial ? (PREFIX + ' ' + initial + '.') : STANDARD_ANON;
    el.textContent = masked;
    el.dataset.jdgmMasked = '1';
  }

  function scan(){
    document.querySelectorAll(
      '.jdgm-rev__author, .jdgm-carousel-item__reviewer, .jdgm-all-reviews__reviewer'
    ).forEach(maskOne);
  }

  // 初次 + 异步渲染兜底
  document.addEventListener('DOMContentLoaded', function(){
    scan();
    setTimeout(scan, 600);
    setTimeout(scan, 1500);
  });

  // 监听后续 DOM 变化（分页/加载更多/轮播）
  var mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
